import Seo from '@/components/base/Seo';
import { Link } from 'react-router-dom';

export default function PrivacyStatement() {
  return (
    <div className="min-h-screen bg-background-50 pt-24 pb-16 px-6">
      <Seo
        title="Privacy Statement | Healing & Breakthrough"
        description="Privacy Statement for Healing & Breakthrough. Our commitment to protecting your personal data and respecting your privacy."
        canonicalPath="/privacy-statement"
      />
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="flex items-center gap-2 text-sm font-semibold text-primary-600 hover:text-primary-700 transition-colors cursor-pointer mb-8"
        >
          <i className="ri-arrow-left-line" aria-hidden="true"></i>
          Back to Home
        </Link>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-primary-800 mb-8">
          Privacy Statement
        </h1>
        <div className="space-y-6 text-sm text-foreground-600 leading-relaxed">
          <p>
            Healing & Breakthrough Coaching is committed to protecting your privacy and ensuring that your personal information is handled in a safe and responsible manner.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            Data Collection
          </h2>
          <p>
            We only collect personal data that is necessary for us to provide our coaching services. This may include your name, email address, and any information you voluntarily provide during consultations.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            Data Protection
          </h2>
          <p>
            We implement appropriate technical and organisational measures to protect your personal data against unauthorised access, alteration, disclosure, or destruction.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            Data Retention
          </h2>
          <p>
            We retain your personal data only for as long as necessary to fulfil the purposes for which it was collected, or as required by applicable law.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            Third-Party Services
          </h2>
          <p>
            We may use third-party services such as Calendly for scheduling and email providers for communication. These services have their own privacy policies.
          </p>

          <h2 className="font-heading text-lg font-semibold text-primary-700 mt-6">
            Changes to This Statement
          </h2>
          <p>
            We may update this privacy statement from time to time. Any changes will be posted on this page with an updated revision date.
          </p>

          <p className="pt-4">
            For any questions regarding this privacy statement, please contact{" "}
            <a href="mailto:federica.tedeschi3@gmail.com" className="text-primary-600 hover:underline">
              federica.tedeschi3@gmail.com
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
}